import { FLIRTING_STYLE_OPTIONS } from '../FLIRTING_STYLE_OPTIONS';
import { FlirtingStyleOptionIdType } from '../types';

export const getFlirtingStyleTitleById = (
  id: FlirtingStyleOptionIdType | null | undefined,
): string | null => {
  if (!id) return null;
  return (
    FLIRTING_STYLE_OPTIONS.find((option) => option.id === id)?.title || null
  );
};

const DEFAULT: FlirtingStyleOptionIdType = 'bold_teasing';

export const getFlirtingStyleIdByTitle = (
  title: string | null | undefined,
  withDefault = false,
): FlirtingStyleOptionIdType | null => {
  const id = FLIRTING_STYLE_OPTIONS.find(
    (option) => option.title === title,
  )?.id;

  if (id) {
    return id;
  }

  if (withDefault) {
    return DEFAULT;
  }

  return null;
};
